/**
 * Created by JasonChou on 17/6/19.
 */
import React, {PureComponent} from 'react'

export default class Button extends PureComponent {
    render() {
        return <div {...this.props}/>
    }
}


// WEBPACK FOOTER //
// ./src/components/Button.js